export default "__VITE_ASSET__B6UOXBJ6__"